var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58182 0 0 3.58182 0 8C0 12.0109 2.95455 15.3225 6.80436 15.9011V10.1204H4.82509V8.01746H6.80436V6.61818C6.80436 4.30146 7.93309 3.28436 9.85855 3.28436C10.7807 3.28436 11.2684 3.35273 11.4993 3.384V5.21964H10.1858C9.36836 5.21964 9.08291 5.99455 9.08291 6.868V8.01746H11.4785L11.1535 10.1204H9.08291V15.9182C12.9876 15.3884 16 12.0498 16 8C16 3.58182 12.4182 0 8 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebook);
export default __webpack_public_path__ + "static/media/ic-facebook.1aed8c8bfb59ac3051ea2759ee62f77f.svg";
export { ForwardRef as ReactComponent };